import { useMemo } from "react";
import { basicDetailSchema } from "./schema";
import { getRequiredFields } from "components/form/utils";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { useUpdateBasicDetails } from "../update/mutation";
import { CASESTUDY_FIELDS } from "../../form/constants";
import { fetchCaseStudyDataforForm } from "../../form/read";
import { useCreateCasestudy } from "../../create/mutation";
import { eventBus } from "utils/eventBus";

export const useBasicDetailForm = ({ casestudyId }) => {
    const navigate = useNavigate();

    const createCasestudyMutation = useCreateCasestudy();
    const updateBasicDetailsMutation = useUpdateBasicDetails();

    const form = useForm({
        resolver: zodResolver(basicDetailSchema),
        defaultValues: {
            status: "draft",
            name: "",
            project: "",
            project_name_alias: "",
            date_started: "",
            tag_line: "",
            team_size: "",
            duration: "",
        },
    });

    const requiredFields = useMemo(
        () => getRequiredFields(basicDetailSchema),
        [basicDetailSchema]
    );

    async function handleCreate(context) {
        const values = context.values;
        const response = await createCasestudyMutation.mutateAsync({
            values,
        });
        navigate(`/case-studies/${response.project.id}`);
    }

    async function handleRead(casestudyId) {
        const fields = [...CASESTUDY_FIELDS];

        const response = await fetchCaseStudyDataforForm({ casestudyId, fields });

        const data = {
            ...response,
        };

        return data;
    }

    async function handleUpdate(id, context) {
        const values = context.dirtyValues;
        const response = await updateBasicDetailsMutation.mutateAsync({
            caseStudyId: id,
            values,
        });
        eventBus.emit("refresh:list", `${casestudyId}`);
        return response;
    }

    return {
        form,
        requiredFields,
        handleCreate,
        handleRead,
        handleUpdate,
    };
};
